export default "__VITE_ASSET__ea7964b6__"